/**
 * Where the session JWT lives in the browser.
 *
 * A single tiny module so both the auth store (which writes it on login) and the
 * API client (which reads it per request) share one source of truth without
 * importing each other — that would be a cycle.
 */
const TOKEN_KEY = 'postpilot-token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}
